import https from 'https';
import axios from 'axios';

const agent = new https.Agent({
  rejectUnauthorized: false,
  // ca: fs.readFileSync("/etc/ssl/certs/rootCA.crt"),        
  // cert: fs.readFileSync("/etc/ssl/certs/postcardpost.k8s.io.crt"),
  // key: fs.readFileSync("/etc/ssl/certs/postcardpost.k8s.io.key"), 
});

let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
    }
  };

const url = 'https://postcardpost.hopto.org/posts';

//export const fetchPosts = () => axios.get(url, {httpsAgent:agent});
//export const fetchPosts = () => axios.get(url, {httpsAgent:agent,axiosConfig});

export const fetchPosts = () => axios.get(url, axiosConfig);

// export const createPost = (newPost) => axios.post(url, newPost, {httpsAgent:agent});
// export const likePost = (id) => axios.patch(`${url}/${id}/likePost`, {httpsAgent:agent});
// export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost, {httpsAgent:agent});
// export const deletePost = (id) => axios.delete(`${url}/${id}`, {httpsAgent:agent});

// export const createPost = (newPost) => axios.post(url, newPost, {httpsAgent:agent,axiosConfig});
// export const likePost = (id) => axios.patch(`${url}/${id}/likePost`, {httpsAgent:agent,axiosConfig});
// export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost, {httpsAgent:agent,axiosConfig});
// export const deletePost = (id) => axios.delete(`${url}/${id}`, {httpsAgent:agent,axiosConfig});


export const createPost = (newPost) => axios.post(url, newPost, axiosConfig);
export const likePost = (id) => axios.patch(`${url}/${id}/likePost`, axiosConfig);
export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost, axiosConfig);
export const deletePost = (id) => axios.delete(`${url}/${id}`, axiosConfig);